export default {
    i18n: {
        "auto": "Auto",
        "Device Name": "Název zařízení",
        "Group": "Skupina",
        "day": "den",
        "Device Information": "Informace o zařízení",
        "handset": "Sluchátko",
        "bluetooth": "Bluetooth",
        "Volume": "Hlasitost",
        "Http": "HTTP",
        "Access Denied.": "Odemčení selhalo",
        "tamperAlarm": "Poplach při neoprávněném zásahu",
        "Card": "Karta",
        "Fingerprint": "Otisk prstu",
        "Date Time": "Datum a čas",
        "name": "Jméno",
        "minutes": "Minuty",
        "timezone": "Časové pásmo",
        "Are you sure you want to delete this device?": "Opravdu chcete toto zařízení odstranit?",
        "Attendance Point Name": "Název docházkového místa",
        "Mac": "MAC",
        "confirmToDeleteIt?": "Přejete si smazat položku?",
        "captureLogs": "Logy záznamů",
        "Doors": "Dveře",
        "All Doors": "Všechny dveře",
        "Lock List": "Seznam zámků",
        "Link Device Relay": "Relé propojení zařízení",
        "Added Successfully!": "Přidáno úspěšně!",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "Když je zámek spojen s relé, zámek bude odemčen, když je spuštěno relé.",
        "Adding...": "Přidávání...",
        "Please try again 24 hours later.": "Zkuste to prosím znovu o 24 hodin později.",
        "Action": "Akce",
        "Address": "Adresa",
        "Owner": "Majitel",
        "Failed": "Selhalo.",
        "Timeout": "Vypršení času",
        "Response": "Odezva",
        "caller": "Volající",
        "receiver": "Příjemce",
        "doorLogs": "Logy vstupů",
        "callHistory": "Historie volání",
        "UID": "UID",
        "Call Type": "Typ hovoru",
        "Code": "Kód",
        "User": "Uživatel",
        "Device List": "Můj seznam monitorů",
        "Model": "Model",
        "Time": "Čas",
        "Company": "Společnost",
        "Property Managers": "Správci objektu",
        "Current Version": "Aktuální verze",
        "indoorMonitor": "Vnitřní jednotka",
        "guardPhone": "Telefon",
        "close": "Zavřít",
        "Success": "Úspěch",
        "URL": "IP vzdáleného relé",
        "Please select a device.": "Vyberte zařízení.",
        "Password is too weak.": "Heslo je příliš slabé.",
        "Company is required.": "Zadejte název společnosti",
        "Your account is not activated, please contact your service provider.": "Váš účet není aktivní. Kontaktujte svého poskytovatele služeb.",
        "Language": "Jazyk",
        "Face": "Obličej",
        "Please set at least one access type.": "Nastavte alespoň jeden typ přístupu.",
        "Please contact your service provider to activate this advanced feature.": "Kontaktujte svého poskytovatele pro aktivaci této funkce.",
        "Community name": "Název komunity",
        "Please enable PM App first.": "Nejprve povolte aplikaci PM.",
        "Username": "Uživatelské jméno",
        "Change Log": "Záznam změn",
        "Assign": "Přiřadit",
        "Floor": "Patro",
        "Link Device": "Připojit zařízení",
        "Accessible Floors": "Přístupná patra",
        "Upgrade": "Aktualizace",
        "Function": "Funkce",
        "callDuration": "Trvání hovoru",
        "No": "Ne",
        "Verification Code": "Ověřovací kód",
        "Expiration Time": "Čas expirace",
        "PIN": "PIN",
        "MAC": "Mac",
        "Building": "Budova",
        "APT": "Apt",
        "ID": "ID",
        "Name": "Jméno",
        "activities": "Aktivity",
        "Obtain": "Přečíst",
        "call": "Hovor",
        "Group Call": "Skupinové volání",
        "Delete": "Smazat",
        "Yes": "Ano",
        "Door Release PIN": "PIN pro otevření dveří",
        "Email": "E-mail",
        "Mobile Number doesn\'t exist.": "Mobilní číslo neexistuje.",
        "Tips": "Tipy",
        "Password": "Heslo",
        "The end time cannot be earlier than the start time.": "Čas ukončení nemůže být dříve než počáteční čas.",
        "Back": "Zpět",
        "File format error.": "Chyba formátu souboru.",
        "motionDetection": "Detekce pohybu",
        "You are trying too often, please try again in 5 minutes": "Zkoušíte to příliš často, zkuste to prosím znovu za 5 minut.",
        "User name too long.": "Uživatelské jméno je příliš dlouhé, maximálně 63 znaků.",
        "This MAC address is redirected on RPS.": "Tato adresa MAC je přesměrována na RPS.",
        "No Answer": "Žádná odpověď",
        "failedToUnlock": "Nepodařilo se odemknout",
        "visitor": "návštěvník",
        "yesterday": "Včera",
        "Too large data! Please first export the data before %s first,thanks.": "Příliš velká data! Nejprve prosím exportujte data před %s, děkuji.",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "Zkontrolujte, zda nejsou nějaké nezaplacené objednávky, pokud ne, obraťte se na svého poskytovatele služeb.",
        "lock": "Zavřít dveře",
        "open": "Otevřít",
        "The PersonalAccount is not active.": "Osobní účet není aktivní.",
        "You cannot link an account that already link other accounts.": "Nelze propojit účet, který již propojuje jiné účty.",
        "You cannot link multiple property manager accounts under the same installer account.": "Pod stejným instalačním účtem nelze propojit více účtů správce majetku.",
        "You cannot link to the currently logged in account.": "Nelze se připojit k aktuálně přihlášenému účtu.",
        "nfc": "NFC",
        "Delete Device": "Smazat zařízení",
        "date": "Datum",
        "Device deleted successfully": "Zařízení bylo úspěšně odstraněno",
        "Failed to delete device": "Nepodařilo se odstranit zařízení",
        "Are you sure you want to cancel?": "Opravdu si přejete zrušit?",
        "Unlimited": "Neomezený",
        "Battery Level": "Úroveň nabití baterie",
        "Password Incorrect.": "Nesprávné heslo.",
        "deliverySystemVerification": "Ověření doručovacího systému",
        "None": "Žádné",
        "unlock": "Odemknout",
        "Upgrading...": "Probíhá aktualizace...",
        "amenityReservation": "Rezervace společných prostor",
        "idAccess": "Přístup k ID",
        "RF Card": "RF karta",
        "exitButton": "Tlačítko pro otevření",
        "Please select at least one item.": "Vyberte alespoň jednu položku.",
        "The ID can contain only digits and letters, up to 32 characters.": "ID může obsahovat pouze číslice a písmena, maximálně 32 znaků",
        "The PIN is not available.": "Tento PIN není k dispozici",
        "Change WiFi": "Změnit Wi-Fi",
        "Phone number": "Telefonní číslo",
        "Invalid {0}.": "Neplatné {0}",
        "{0} already exists.": "{0} již existuje",
        "Operation failed!": "Operace selhala!",
        "Failed to get data.": "Nepodařilo se načíst data",
        "You do not have the necessary permissions to perform this operation.": "Nemáte potřebná oprávnění pro tuto operaci.",
        "You can only import one template at a time in the current site.": "V aktuálním projektu lze importovat pouze jednu šablonu současně.",
        "Delivery name": "Název oprávnění pro doručování",
        "MAC address not in the MAC library.": "MAC adresa není v databázi MAC",
        "Please delete devices under this building.": "Nejprve smažte zařízení pod touto budovou",
        "The start time cannot be later than the end time.": "Počáteční čas nesmí být po koncovém čase",
        "emergency action type": "Typ nouzové akce",
        "Only 1000 data items can be imported at a time.": "Lze importovat maximálně 1000 položek najednou.",
        "The password is too short.": "Heslo je příliš krátké",
        "The data has been updated. Please refresh the page and try again.": "Data byla aktualizována. Obnovte stránku a zkuste to znovu.",
        "AutoP length must be less 2048 bytes.": "Délka AutoP příkazu musí být menší než 2048 bajtů",
        "File Check Failed": "Kontrola souboru selhala",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "Přihlášení správcovského účtu vypršelo. Kontaktujte svého poskytovatele služby.",
        "iqPinVerificationFailed": "Ověření IQ PIN selhalo.",
        "accountBlacklisted": "Účet byl zablokován.",
        "outsideAuthorizedTime": "Mimo povolenou dobu.",
        "network group": "Síťová skupina",
        "Company name": "Název společnosti",
        "Group name": "Název skupiny",
        "relay": "Dveře",
        "motionTime": "čas detekce pohybu",
        "motionType": "typ detekce pohybu",
        "postalCode": "poštovní směrovací číslo",
        "floor format": "formát patra",
        "mobilePhone": "mobilní telefon",
        "time format": "Formát času",
        "security relay": "Bezpečnostní relé",
        "Param": "Parametr",
        "Offline Code": "Offline kód",
        "Add akubela Smart Locks": "Přidat chytré zámky akubela",
        "Module Version": "Verze modulu",
        "Lock Body Version": "Verze těla zámku",
        "Available Version": "Dostupná verze",
        "Please wake up the lock screen and then upgrade.": "Probuďte obrazovku zámku a poté proveďte upgrade.",
        "This process will take some time, please be patient.": "Tento proces může chvíli trvat, buďte prosím trpěliví.",
        "Please confirm that the WiFi network is functioning properly.": "Potvrďte, že WiFi síť funguje správně.",
        "Please wake up the lock screen.": "Probuďte, prosím, zámek obrazovky.",
        "This lock has already been added to another apartment.": "Tento zámek už byl přidán do jiné jednotky.",
        "This lock has already been added to the apartment.": "Tento zámek je už přidán do jednotky.",
        "Pin Code": "PIN kód",
        "Too many failed attempts, please try again in a few minutes.": "Příliš mnoho neúspěšných pokusů, zkuste to znovu za pár minut.",
        "Login Account": "Přihlašovací účet",
        "Same account cannot login in different ins.": "Stejný účet se nemůže přihlásit u různých instalačních společností",
        "Lock Name": "Název zámku",
        "Smart Locks": "Chytré zámky",
        "Add Smart Lock": "Přidat chytrý zámek",
        "The selected duration cannot be more than one year.": "Zvolená doba nesmí přesáhnout jeden rok.",
        "The end time of the break time cannot be later than the end work time.": "Konec přestávky nesmí být později než konec pracovní doby.",
        "The start time of the break time cannot be earlier than the start work time.": "Začátek přestávky nesmí být dříve než začátek pracovního dne.",
        "The end time of the valid check time cannot be earlier than the end work time.": "Konec platného času kontroly nesmí být dříve než konec pracovní doby.",
        "The start time of the valid check time cannot be later than the start work time.": "Začátek platného času kontroly nesmí být později než start pracovní doby.",
        "Deleting failed. The timetable is used by a shift.": "Mazání se nezdařilo. Rozvrh je používán směnou.",
        "Deleting failed. The shift is in use.": "Mazání se nezdařilo. Směna je používána.",
        "Deleting failed. The leave type is in use.": "Mazání se nezdařilo. Typ dovolené je právě používán.",
        "Valid time conflicts with an existing schedule.": "Platný čas koliduje s existujícím rozvrhem.",
        "The timing for multiple schedules must not coincide.": "Časy v několika rozvrzích se nesmí překrývat.",
        "Attendance Log": "Docházkový záznam",
        "Added Failed!": "Přidání se nezdařilo!",
        "Setting WiFi": "Nastavuji Wi-Fi",
        "License Plate": "SPZ",
        "key": "Tlačítko",
        "IQ Offline.": "IQ offline",
        "{0}Unlock": "{0} Odemknout",
        "automatically": "Automaticky",
        "manually": "Manuálně",
        "Video Storage": "Ukládání videa",
        "Device(s) for Video Storage": "Zařízení pro ukládání videa",
        "The amount of exported data is too large. Please export it in batches.": "Objem exportovaných dat je příliš velký. Exportujte prosím po dávkách.",
        "Auto-record video when door unlocks": "Automatické nahrávání videa při odemčení dveří",
        "Auto-record video during calls": "Automatické nahrávání videa během hovorů",
        "Manual video recording in monitoring": "Ruční nahrávání videa v režimu monitorování",
        "Saved for 30days/60days/90days": "Uloženo 30/60/90 dní",
        "To subscribe, please contact your provider for activation.": "Chcete-li si předplatit službu, kontaktujte svého poskytovatele pro aktivaci.",
        "Saved for {0}days": "Uloženo po dobu {0} dní",
        "Subscribed Plan": "Předplacený plán",
        "Supported Devices: {0}": "Podporovaná zařízení: {0}",
        "{0}Lock": "{0} Zamknout",
        "Video Saving": "Ukládání videa",
        "Download Completed!": "Stažení dokončeno!",
        "Fail to download.": "Stažení selhalo.",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "Smazání se nezdařilo! Správce nemovitosti je již propojen s účtem RentManager, nejprve jej musíte odstranit.",
        "No log to be exported.": "Žádný log ke stažení.",
        "capture&Video": "Snímek & Video",
        "packageDetection": "Detekce balíčku",
        "Time format is invalid.": "Formát času je neplatný.",
        "No permission to export logs of this type.": "Nemáte oprávnění exportovat logy tohoto typu.",
        "Project type is invalid.": "Typ projektu je neplatný.",
        "Salto Account Blocked.": "Účet Salto byl zablokován.",
        "Remote open not in access group.": "Vzdálené otevření není v přístupové skupině.",
        "SIP Account required.": "SIP účet je povinný.",
        "The PIN must be {0} digits.": "PIN musí mít {0} číslic.",
        "gatewayConnectionUnavailable": "Připojení ke bráně není dostupné.",
        "Invalid Username or Password": "Neplatné uživatelské jméno nebo heslo.",
        "Account already linked to another user.": "Účet je již svázán s jiným uživatelem.",
        "The account has been added by another user.": "Účet již byl přidán jiným uživatelem.",
        "Failed to add. This user already has 5 license plates.": "Nelze přidat. Tento uživatel již má 5 značek.",
        "Please at least select a door.": "Vyberte alespoň jedny dveře.",
        "UHF Card": "UHF karta",
        "personnel": "Personál",
        "Parking Lot Name": "Název parkoviště",
        "Controlled Relay": "Ovládané relé",
        "No Permission": "Nemáte oprávnění",
        "Please ensure that all doors in the project are activated at the same time.": "Ujistěte se, že všechny dveře v projektu byly aktivovány současně.",
        "gatewayBusy": "Brána je zaneprázdněná",
        "Please set the perimeter door group first.": "Nejprve prosím nastavte skupinu obvodových dveří.",
        "Please ensure that all doors in the project are renewed at the same time.": "Ujistěte se, že všechny dveře v projektu jsou obnoveny současně.",
        "When lockdown is on, the controlled relay cannot be modified.": "Při aktivaci uzamčení nelze ovládané relé upravovat.",
        "DetectionLogs": "Záznamy detekce",
        "packageIn": "Vložení balíčku",
        "packageOut": "Vyjmutí balíčku",
        "View Progress": "Zobrazit průběh",
        "Check if the WiFi is operating on the 2.4GHz band.": "Zkontrolujte, zda Wi-Fi funguje v pásmu 2,4 GHz.",
        "Verify that the WiFi password is correct.": "Ověřte, že je heslo k Wi-Fi správné.",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "Ujistěte se, že jste během konfigurace hotspotu připojeni ke správnému hotspotu zařízení.",
        "Offline Code Unlock": "Odemknout offline kódem",
        "Salto Token Expired.": "Salto token vypršel.",
        "Lock Offline": "Zámek offline",
        "identity information! Please login again": "Identifikační informace! Přihlaste se znovu",
        "Email is required.": "E-mail je povinný.",
        "Mobile number is required.": "Je vyžadováno mobilní číslo.",
        "You can\'t make payments for offices in different time zones.": "Nemůžete provádět platby za kanceláře v různých časových pásmech.",
        "The current scheduling staff exceeds 200 people.": "Aktuálně naplánovaný personál překračuje 200 osob.",
        "param": "parametr",
        "Invalid UserName or Password": "Neplatné uživatelské jméno nebo heslo",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "Váš účet Salto KS nemá oprávnění upravit název zámku.",
        "Owner is required.": "Vlastník je povinný.",
        "Office is required.": "Kancelář je povinná.",
        "PIN or RF Card is required.": "Je vyžadován PIN nebo RF karta.",
        "RF card": "Přístupová karta",
        "Personnel is required.": "Je vyžadován personál.",
        "email address": "e-mailová adresa",
        "mobile number": "telefonní číslo",
        "The length must be less than 32 characters.": "Délka musí být menší než 32 znaků.",
        "The length must be less than 256 characters.": "Délka musí být menší než 256 znaků.",
        "Access Group is required.": "Přístupová skupina je povinná.",
        "Device is required.": "Zařízení je povinné.",
        "Admin is required.": "Je vyžadován administrátor.",
        "Mobile number": "Telefonní číslo",
        "schedules": "Rozvrhy",
        "Timetable name": "Název rozvrhu",
        "Shift name": "Název směny",
        "Leave type": "Druh dovolené",
        "recheck in time": "Čas opětovného přihlášení",
        "recheck out time": "Čas opětovného odhlášení",
        "The building name": "Název budovy",
        "Building is required.": "Budova je vyžadována.",
        "selection, The same reader cannot be set for both entry and exit": "výběr, Stejný čtečka nemůže být nastavena pro vstup i výstup",
        "Door number": "Číslo dveří",
        "door input cannot be selection duplicated.": "Vstup dveří nemůže být vybrán vícekrát.",
        "Group is required.": "Je vyžadována skupina.",
        "Title can contain up to 32 characters.": "Název může mít maximálně 32 znaků.",
        "Content can contain up to 1024 characters.": "Obsah může mít maximálně 1024 znaků.",
        "Content can contain up to 64 characters.": "Obsah může mít maximálně 64 znaků.",
        "Report is required.": "Zpráva je povinná.",
        "ID is required.": "ID je povinné.",
        "The office does not exist.": "Kancelář neexistuje.",
        "Office name": "Název kanceláře",
        "The Temp Key does not exist.": "Dočasný klíč neexistuje.",
        "autolock time": "Čas automatického uzamčení",
        "The User does not exist.": "Uživatel neexistuje.",
        "The Installer does not exist.": "Instalatér neexistuje.",
        "The Project does not exist.": "Projekt neexistuje.",
        "The Distributor does not exist.": "Distributor neexistuje.",
        "The Community Device does not exist.": "Zařízení komunity neexistuje.",
        "The Property Manager does not exist.": "Správce komunity neexistuje.",
        "The Sub Distributor does not exist.": "Subdistributor neexistuje.",
        "The Single Slave does not exist.": "Jednotlivý podřízený účet neexistuje.",
        "The Property Manager EndUser does not exist.": "Koncový uživatel správce nemovitosti neexistuje.",
        "The Family Member does not exist.": "Člen rodiny neexistuje.",
        "Set Failed!": "Nastavení selhalo!",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "Dostali jste se k limitu 10 požadavků na offline kód za 30 minut. Zkuste znovu později.",
        "This Email doesn\'t exist.": "E-mail neexistuje.",
        "detection type": "Typ detekce",
        "Device UUID": "UUID zařízení",
        "smart lock device": "chytrý zámek",
        "You are trying too often, please try again in 5 minutes.": "Operace je příliš častá, zkuste to za 5 minut.",
        "You can only import one file at a time. Please wait for the current import to finish.": "Najednou můžete importovat pouze jeden soubor. Počkejte prosím, až bude aktuální import dokončen.",
        "NVR Name": "Název NVR",
        "NVR Address": "Adresa NVR",
        "Stay Alarm": "Alarm pro dlouhodobý pobyt",
        "Happended On": "Došlo dne",
        "Edit Milesight NVR": "Upravit Milesight NVR",
        "Add Milesight NVR": "Přidat Milesight NVR",
        "Auto-record video on motion detection, package detection": "Automatické nahrávání videa při detekci pohybu nebo balíčku",
        "A 7-day free trial is included with your subscription.": "Vaše předplatné zahrnuje 7denní bezplatnou zkušební dobu.",
        "For service renewal, please reach out to your provider.": "Pro obnovení služby kontaktujte svého poskytovatele.",
        "Allow the Property Manager to view recorded videos": "Povolit správci objektu prohlížet nahraná videa",
        "Please ensure the WiFi network is working properly.": "Ujistěte se, že WiFi síť funguje správně.",
        "Edit akubela Smart Locks": "Upravit chytré zámky akubela",
        "Upgraded Successfully!": "Aktualizace proběhla úspěšně!",
        "Upgraded Failed!": "Aktualizace selhala!",
        "Editing...": "Probíhá úprava...",
        "Edited successfully!": "Úprava proběhla úspěšně!",
        "Edited Failed!": "Úprava selhala!",
        "Downloading video...": "Stahuji video...",
        "All Locks": "Všechny zámky",
        "Select Locks": "Vyberte zámky",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "{0}-místný PIN lze použít, jakmile je chytrý zámek akubela připojen k síti. Upozorňujeme, že po synchronizaci může PIN nabýt platnosti s krátkým zpožděním.",
        "Please at least select a door or a lock.": "Vyberte alespoň jedny dveře nebo jeden zámek.",
        "This lock has already been added to your apartment.": "Tento zámek již byl do vašeho bytu přidán.",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "Tento zámek už byl přidán do jiného bytu, kontaktujte svého poskytovatele služeb pro asistenci.",
        "LockBody Version": "Verze těla zámku",
        "Two-factor Authentication": "Dvoufaktorové ověřování",
        "Monitoring Scope": "Rozsah monitorování",
        "Stay Duration": "Doba pobytu",
        "Volume Settings": "Nastavení hlasitosti",
        "get card list for lock error": "Chyba při získávání seznamu karet pro zámek",
        "get card list parse fail": "Nepodařilo se analyzovat seznam karet",
        "get pin list for lock error": "Chyba při získávání seznamu PINů pro zámek",
        "get pin list parse fail": "Nepodařilo se analyzovat seznam PINů",
        "fingerprint code must be less than 2048 characters or empty.": "Kód otisku prstu musí mít méně než 2048 znaků nebo být prázdný.",
        "Personnel not in office.": "Personál není v kanceláři.",
        "customize form fail.": "Přizpůsobení formuláře selhalo.",
        "smart lock type error.": "Chyba typu chytrého zámku.",
        "invalid client id or secret": "Neplatné klientské ID nebo tajný klíč",
        "invalid account or password": "Neplatný účet nebo heslo",
        "invalid access token": "Neplatný přístupový token",
        "invalid refresh token": "Neplatný token pro obnovení",
        "no permission to access this project": "Nemáte oprávnění k přístupu k tomuto projektu",
        "Stay Alarm Time": "Doba trvání poplachu",
        "This function only support sl20 lock.": "Tato funkce je podporována pouze zámkem SL20.",
        "Json marshal error.": "Chyba serializace Json.",
        "Json unmarshal error.": "Chyba deserializace Json.",
        "Illegal request, not added within valid time.": "Neoprávněný požadavek, nebylo přidáno v platném čase.",
        "invalid nvr type": "Neplatný typ NVR",
        "project is empty": "Projekt je prázdný",
        "project type is invalid": "Neplatný typ projektu",
        "owner is invalid": "Neplatný vlastník",
        "url is invalid": "Neplatná URL adresa",
        "password is invalid": "Neplatné heslo",
        "building is invalid": "Neplatná budova",
        "fail to get data": "Nepodařilo se získat data",
        "invalid allow pm view type": "Neplatný typ povoleného zobrazení PM",
        "Data not exist.": "Data neexistují.",
        "cannot find community PrivateKey.": "Nelze najít soukromý klíč komunity.",
        "cannot find single PrivateKey.": "Nelze najít jednotlivý soukromý klíč.",
        "The third party not exist.": "Třetí strana neexistuje.",
        "{0} and indoor monitors/guard phones": "{0} a vnitřní monitory/správcovské telefony",
        "{0} and indoor monitors/guard phones, with phone as backup": "Nejprve {0} a vnitřní monitory/správcovské telefony, pokud nikdo neodpoví, pak telefon",
        "Indoor monitors/guard phones with {0} as backup": "Nejprve vnitřní monitory/správcovské telefony, pokud nikdo neodpoví, pak {0}",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "Nejprve vnitřní monitory/správcovské telefony, pokud nikdo neodpoví, pak {0}, nakonec telefon",
        "{0} Intercom Feature": "Funkce interkomu {0}",
        "Capture on {0}": "Snímek na {0}",
        "{0} Intercom Feature is not activated or has expired.": "Funkce interkomu {0} není aktivována nebo vypršela.",
        "fingerprint code must be equal 1620 characters or empty.": "Kód otisku prstu musí mít přesně 1620 znaků nebo být prázdný.",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "Aby se upgrade podařil, ujistěte se, že úroveň baterie zámku je více než 40 %, než budete pokračovat.",
        "Automatic Locking Time": "Čas automatického uzamčení",
        "WiFi Keep-Alive": "Udržování Wi-Fi",
        "WiFi Setting": "Nastavení Wi-Fi",
        "Connecting the network...": "Probíhá připojení k síti...",
        "Set successfully!": "Nastavení úspěšné!",
        "The offline code can be used even if the lock is not connected to WiFi.": "Offline kód lze použít i tehdy, když není zámek připojen k Wi-Fi.",
        "Enabling this feature will increase the lock\'s power consumption.": "Povolení této funkce zvýší spotřebu energie zámku.",
        "Each offline code can only be used once.": "Každý offline kód lze použít pouze jednou.",
        "Receiver Info": "Informace o příjemci",
        "log id": "ID přihlášení",
        "Create HW SN Config Empty SN.": "Vytvoření konfigurace HW SN – SN je prázdné.",
        "The SN": "Sériové číslo",
        "SN can contain up to 32 characters.": "SN může obsahovat maximálně 32 znaků.",
        "Check HW SN Not Found.": "Kontrola HW SN – nenalezeno.",
        "the end user not found": "Koncový uživatel nenalezen",
        "Family Call": "Rodinný hovor",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "Během upgradu budou všechny funkce související se zámkem dočasně nedostupné.",
        "8-digit PIN code starting with \"9\" is invalid!": "8místný PIN začínající číslicí \'9\' je neplatný!",
        "Lock name length must be between 1 and 50": "Název zámku musí mít 1 až 50 znaků",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "Počet osob s pevnou linkou nesmí překročit počet těch, kteří používají {0} interkom.",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "Počet správců s pevnou linkou nesmí překročit počet správců s {0} interkomem.",
        "charge type": "typ poplatku",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "Počet zaměstnanců s pevnolinkovou službou nesmí překročit počet těch se službou SmartPlus Intercom.",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "Počet správců s pevnolinkovou službou nesmí překročit počet těch se službou SmartPlus Intercom.",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "Čtečka nemůže být nakonfigurována pro současné použití Wiegand i RS485.",
        "parameter error": "Chyba parametru",
        "community name already exist": "Název komunity již existuje",
        "personnel app without intercom feature number": "Personální aplikace bez čísla funkce interkomu",
        "check feature billing charge plan new error": "Chyba při kontrole nového plánu účtování funkcí",
        "subscription not found": "Předplatné nebylo nalezeno",
        "System setting record not found.": "Záznam nastavení systému nebyl nalezen.",
        "Smart home not enabled.": "Chytrá domácnost není aktivována.",
        "the apt call type value is invalid.": "Hodnota typu volání bytu je neplatná.",
        "the ip call or sip call value is invalid.": "Hodnota pro IP nebo SIP volání je neplatná.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "PIN kód musí být 2–8místné číslo, ale nemůže to být 8místné číslo začínající číslicí 9 nebo prázdné.",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard musí obsahovat znaky A-F0-9, být kratší než 16 znaků nebo být prázdná.",
        "owner cannot be empty.": "Vlastník nesmí být prázdný.",
        "creator cannot be empty.": "Tvůrce nesmí být prázdný.",
        "the creator type value is invalid": "Typ tvůrce je neplatný",
        "the IsCreateByPm value is invalid": "Hodnota IsCreateByPm je neplatná",
        "the pinCode already exist": "PIN kód již existuje",
        "the rfCard already exist": "rfCard již existuje",
        "license plate is invalid.": "SPZ je neplatná.",
        "owner info is invalid.": "Informace o vlastníkovi jsou neplatné.",
        "uhf is invalid.": "UHF je neplatné.",
        "time control is invalid.": "Časové ovládání je neplatné.",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "Dosáhli jste limitu 5 SPZ a není možné přidávat další",
        "the plate already exist": "SPZ již existuje",
        "the uhf already exist": "UHF již existuje",
        "empty community": "Prázdná komunita",
        "no find license Plate": "Nelze najít SPZ",
        "IDAccess mode must be 0, 1, or 2.": "Režim IDAccess musí být 0, 1 nebo 2.",
        "Run field is required when mode is 1 or 2.": "Pole Provoz je povinné, pokud je režim 1 nebo 2.",
        "Serial field is required when mode is 2.": "Pole Sériové číslo je povinné, pokud je režim 2.",
        "the pin cannot be empty": "PIN nemůže být prázdný",
        "the rfCard cannot be empty": "rfCard nemůže být prázdná",
        "the IDAccess already exist": "IDAccess již existuje",
        "the resident cannot be empty": "Rezident nesmí být prázdný",
        "the fingerprint cannot be empty": "Otisk prstu nemůže být prázdný",
        "the face cannot be empty": "Obličej nesmí být prázdný",
        "not found pin": "PIN nenalezen",
        "not found rfCard": "rfCard nenalezena",
        "not found IDAccess": "IDAccess nenalezeno",
        "not found fingerprint": "Otisk prstu nenalezen",
        "not found face": "Obličej nenalezen",
        "face pic is invalid.": "Fotografie obličeje je neplatná.",
        "community build and room cannot be empty.": "Stavba komunity a místnost nemohou být prázdné.",
        "device info mac cannot be empty.": "MAC adresa zařízení nesmí být prázdná.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "Typ plánovače musí být 0, 1 nebo 2, nebo je formát času neplatný, nebo dataflag není v rozmezí 0-127.",
        "MAC address cannot be empty.": "MAC adresa nesmí být prázdná.",
        "MAC address 0C1105000000 is not allowed.": "MAC adresa 0C1105000000 není povolena.",
        "MAC address must be 12 hexadecimal characters.": "MAC adresa musí mít 12 hexadecimálních znaků.",
        "Scheduler type value is invalid.": "Hodnota typu plánovače je neplatná.",
        "parse is fail": "Analýza se nezdařila",
        "the fingerprint already exist": "Otisk prstu již existuje",
        "the licensePlate cannot be empty": "SPZ nemůže být prázdná",
        "the licensePlate already exist": "SPZ již existuje",
        "idaccess run must be 10 digit number or end with -K.": "Provoz IDAccess musí být 10místné číslo nebo končit na -K.",
        "idaccess serial must be 9 digit number.": "Sériové číslo IDAccess musí být 9místné číslo.",
        "relay not in 0-15": "Relé není v rozmezí 0–15",
        "security relay not in 0-3": "Bezpečnostní relé není v rozmezí 0–3",
        "file name is wrong": "Název souboru je chybný",
        "access mode specified": "Zvolený režim přístupu",
        "create community user accessmode failed.": "Nepodařilo se vytvořit přístupový režim uživatele komunity.",
        "delete community user accessmode failed.": "Nepodařilo se odstranit přístupový režim uživatele komunity.",
        "Cannot delete building because it has associated users.": "Nelze smazat budovu, protože má přiřazené uživatele.",
        "Cannot delete building because it has associated Salto devices.": "Nelze odstranit budovu, protože je k ní přiřazeno zařízení Salto.",
        "community building not found": "Budova komunity nebyla nalezena",
        "Invalid Name Display": "Neplatné zobrazení jména",
        "The Community does not exist.": "Komunita neexistuje.",
        "Update CommunityIsInstallerKit Error.": "Chyba při aktualizaci CommunityIsInstallerKit.",
        "Dis Not SupportCommunityCalls Error.": "Zprostředkovatel nepodporuje komunitní hovory.",
        "Community Has Special Device, Not Allowed To Delete.": "Komunita má speciální zařízení, nelze smazat.",
        "The project smart home switch must be disabled": "Přepínač chytré domácnosti projektu musí být deaktivován",
        "There are ITec Locks in project": "V projektu jsou Itec zámky",
        "There are Salto Locks in project": "V projektu jsou Salto zámky",
        "There are Dormakaba Locks in project": "V projektu jsou Dormakaba zámky",
        "It is rent manager project": "Jedná se o projekt pro správu pronájmu",
        "It is installer account": "Je to účet instalatéra",
        "contact preference type": "typ preferovaného kontaktu",
        "Floor list is required when not all floors.": "Seznam podlaží je vyžadován, pokud se nejedná o všechna podlaží.",
        "Building floors list is required when all buildings.": "Pokud se jedná o všechny budovy, je vyžadován seznam podlaží budovy.",
        "Indoor monitor name is required.": "Název vnitřního monitoru je povinný.",
        "The primary account is not activated.": "Primární účet není aktivován.",
        "You can\'t create more family member accounts.": "Nemůžete vytvořit více účtů členů rodiny.",
        "community user not found": "Uživatel komunity nebyl nalezen",
        "community is empty": "Komunita je prázdná",
        "the end user not master user": "Koncový uživatel není hlavní uživatel",
        "the end user not member user": "Koncový uživatel není uživatel člen",
        "The email already exists and cannot be repeated": "E-mail již existuje, nelze jej opakovat",
        "The mobile Number already exists": "Telefonní číslo již existuje",
        "The room number format error.": "Chyba ve formátu čísla pokoje.",
        "community not found": "Komunita nebyla nalezena",
        "resident not found": "Rezident nenalezen",
        "installer not found": "Instalatér nenalezen",
        "Operation Failed!": "Operace se nezdařila!",
        "You don\'t have operate permission": "Nemáte oprávnění k provádění operací",
        "You cannot select Relay and Door at the same time": "Nemůžete zároveň vybrat relé i dveře",
        "user don\'t active": "Uživatel není aktivní",
        "User has expired": "Uživatelům vypršela platnost",
        "timestamp must be within 3 minutes of current server time": "Časové razítko musí být v rozmezí 3 minut od aktuálního času serveru",
        "cannot find single rf Card.": "Nelze najít jednotlivou rfCard.",
        "cannot find community rf Card.": "Nelze najít komunitní rfCard.",
        "smartLock model": "model chytrého zámku",
        "the project does not open smart home": "Projekt nepovoluje chytrou domácnost",
        "php web server error": "Chyba PHP webového serveru",
        "Ins not found.": "Ins nenalezen.",
        "RentManage Unit Not Set.": "Jednotka RentManage není nastavena.",
        "add audit log error": "Chyba při přidávání záznamu auditu",
        "check building in error": "Chyba při kontrole budovy",
        "Special devices cannot be deleted": "Speciální zařízení nelze smazat",
        "the email is empty": "E-mail je prázdný",
        "the email format is incorrect": "Formát e-mailu je nesprávný",
        "the mobile number is empty": "Telefonní číslo je prázdné",
        "the mobile number format is incorrect": "Formát telefonního čísla je nesprávný",
        "Site not found": "Projekt nebyl nalezen",
        "User not found": "Uživatel nebyl nalezen",
        "invalid time format": "Neplatný formát času",
        "ground floor type": "formát přízemí",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "Chyba počátečního patra, platné hodnoty jsou -10 až -1, G0, G1, G2, 1 až 128.",
        "Building ID must be between 1 and 99.": "ID budovy musí být mezi 1 a 99.",
        "Community building name": "Název budovy komunity",
        "Building ID already exists in this community.": "ID budovy již v této komunitě existuje.",
        "building ID": "ID budovy",
        "Community building not found.": "Budova komunity nebyla nalezena.",
        "Cannot delete building because it has associated devices.": "Nelze smazat budovu, protože má přiřazená zařízení.",
        "project is not valid": "Projekt není platný",
        "Cannot delete building because it has associated salto devices.": "Budovu nelze smazat, protože má přiřazená zařízení salto.",
        "Cannot delete building because it has associated iTec devices.": "Budovu nelze smazat, protože má přiřazená iTec zařízení.",
        "Cannot delete building because it has associated dormakaba devices.": "Budovu nelze smazat, protože má přiřazená zařízení dormakaba.",
        "member limit num": "Limit počtu členů",
        "Indoor Monitor No Set Error.": "Chyba: Vnitřní monitor není nastaven.",
        "The room not has indoor": "Místnost nemá vnitřní jednotku.",
        "check user in building error": "zkontrolujte chybu uživatele v budově",
        "The name specified is already in use.": "Zadané jméno se již používá.",
        "This timeblock overlaps with an existing one. Please adjust it.": "Tento časový blok se překrývá s již existujícím. Prosím upravte jej.",
        "This door status changed. Please try again.": "Stav těchto dveří se změnil. Zkuste to prosím znovu.",
        "the lock can\'t bind this community": "zámek nemůže tuto komunitu propojit",
        "The custom quantity limit has been exceeded!": "Byl překročen vlastní limit množství!",
        "This time span overlaps with an existing one. Please adjust it.": "Tento časový úsek se překrývá s již existujícím. Prosím upravte jej.",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "Tento jednorázový časový plán se překrývá s existujícím jednorázovým časovým plánem. Prosím, upravte jej.",
        "Operation Failed. Please try again.": "Operace se nezdařila. Zkuste to prosím znovu.",
        "The image is not a front view.": "Obrázek není z předního pohledu.",
        "A mask was detected.": "Byla detekována rouška.",
        "The image resolution is too low.": "Rozlišení obrázku je příliš nízké.",
        "No face was detected.": "Nebyla detekována žádná tvář.",
        "The file size is too large.": "Velikost souboru je příliš velká.",
        "The face in the image is too large.": "Obličej na obrázku je příliš velký.",
        "The face in the image is too small.": "Obličej na obrázku je příliš malý.",
        "Multiple faces detected.": "Bylo detekováno více tváří.",
        "The face is not clear enough.": "Obličej není dostatečně jasný.",
        "Face detection failed.": "Detekce obličeje se nezdařila.",
        "Please enter a value between 1 and 9999": "Zadejte prosím hodnotu mezi 1 a 9999.",
        "Please select which input your door sensor is connected to.": "Vyberte, ke kterému vstupu je váš dveřní senzor připojen.",
        "Add temp key failed, please try it again": "Přidání dočasného klíče se nezdařilo, zkuste to prosím znovu",
        "Dis Not Support Dynamic QRCode Error.": "Dis Nepodporuje Chybu Dynamického QR Kódu.",
        "QR code not exist": "QR kód neexistuje",
        "The temp key has expired.": "Dočasný klíč vypršel.",
        "The device is not in the office": "Zařízení není v kanceláři.",
        "The device is already assigned.": "Zařízení je již přiřazeno.",
        "The device cannot be assigned to any user.": "Zařízení nelze přiřadit žádnému uživateli.",
        "You cannot select an option with fewer users than the current project members.": "Nemůžete vybrat možnost s menším počtem uživatelů, než je aktuální počet členů projektu.",
        "File check failed. Please download the latest template and try again.": "Kontrola souboru selhala. Stáhněte si prosím nejnovější šablonu a zkuste to znovu.",
        "Dynamic QR Code not active.": "Dynamický QR kód není aktivní.",
        "Dynamic QR Code not enable.": "Dynamický QR kód není povolen.",
        "{0} not found.": "{0} nebyl nalezen.",
        "Tier charge plan": "Stupňovaný tarifní plán",
        "Feature billing charge plan new": "Plán účtování poplatků za novou funkci",
        "Feature billing gradient charge plan": "Plán odstupňovaného účtování funkcí",
        "The exit time cannot be earlier than the entry time.": "Čas odjezdu nemůže být dřívější než čas příjezdu.",
        "User Name or Password": "Uživatelské jméno nebo heslo",
        "You can only link up to 5 sites.": "Můžete propojit nejvýše 5 lokalit.",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "Tato registrační značka je již registrována na rezidenta a nelze ji přidat na seznam blokovaných.",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "Tato poznávací značka je na černé listině a nelze ji registrovat jako vozidlo.",
        "Elevator not configured in company access floor.": "Výtah není nakonfigurován v přístupovém patře společnosti.",
        "the device is not in the office": "Zařízení není v kanceláři.",
        "A maximum of 1000 data items can be imported": "Lze importovat maximálně 1000 datových položek.",
        "Exit time cannot be later than the current time.": "Čas odchodu nemůže být pozdější než aktuální čas.",
        "You can only import a file at a time in the current parking lot.": "Na aktuálním parkovišti můžete najednou importovat pouze jeden soubor.",
        "The license plate is already in the blocklist.": "Registrační značka je již v seznamu blokovaných.",
        "Building name too long.": "Název budovy je příliš dlouhý.",
        "Unlock failed. Permission denied by user.": "Odemknutí se nezdařilo. Uživatel odmítl udělit oprávnění.",
        "Please remove the sensor device(s) before disabling this feature.": "Před vypnutím této funkce prosím odeberte zařízení senzoru(ů).",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "Operace se nezdařila! U tohoto uživatele byl překročen denní limit 15 záznamů.",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "V každém projektu lze přidat až {0} veřejných zařízení. Pokud chcete přidat další, kontaktujte technickou podporu Akuvox na support{'@'}akuvox.com.",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "V každém projektu lze přidat až {0} účtů zaměstnanců. Pokud chcete přidat další, kontaktujte technickou podporu Akuvox na support{'@'}akuvox.com.",
        "cancel": "Zrušit",


    }
};
